import { isFunction } from "../utils/is.js";
//#region src/api/ItemBuffer.ts
var ItemBuffer = class {
	constructor() {
		this.buffer = [];
	}
	addItem(item) {
		this.buffer.push(item);
	}
	flushBuffer(cb) {
		if (isFunction(cb)) for (const item of this.buffer) cb(item);
		this.buffer.length = 0;
	}
	size() {
		return this.buffer.length;
	}
};
//#endregion
export { ItemBuffer };

//# sourceMappingURL=ItemBuffer.js.map